import posthog from "posthog-js";

const POSTHOG_KEY = process.env.NEXT_PUBLIC_POSTHOG_PROJECT_TOKEN;
const POSTHOG_HOST = process.env.NEXT_PUBLIC_POSTHOG_HOST;

if (POSTHOG_KEY) {
  posthog.init(POSTHOG_KEY, {
    api_host: "/ingest",
    ui_host: POSTHOG_HOST,
    defaults: "2026-01-30",
    capture_exceptions: true,
    capture_pageview: true,
    capture_pageleave: true,
    person_profiles: "identified_only",
    custom_campaign_params: ["ref"],
    debug: process.env.NODE_ENV === "development",
  });
  posthog.register({
    environment: process.env.NEXT_PUBLIC_APP_ENV ?? "development",
  });
  // window.posthog global — the hydration-stall guard's inline script reads it.
  if (typeof window !== "undefined") {
    (window as Window & { posthog?: typeof posthog }).posthog = posthog;
  }
}
